import { BaseEntity } from "yt-ng-framework";

export class FakDokumentStavka extends BaseEntity{
    constructor(){
        super();
    }    

    FakDokumentID: number = null;
    VrstaStavkiID: number = null;
    TarifaID: number = null;
    Kolicina: number = null;
    Cena: number = null;
    RabatProc: number = null;
    RabatVred: number = 0;
    Opis: string = null; 
    CenaSaPDV: number = null;
    Rabat = null;
    // RabatTip: boolean = null;
    RabatTip: boolean = false;
    JedinicaMereID: number = null;
    // Osnovica: number = null;
    RobaUsluga: string=null;
    VrednostPreRabataStavke: number=null;
//    RabatStavke: number = null;
    RabatStavke: number = 0;
    OsnovicaStavke: number=null;
    PdvStavke: number=null;
    VrednostStavke: number=null;
    IdentifikatorKlasifikacije: string = null;

    Deserialize(input:any){
        super.Deserialize(input);
        this.ID=input.ID;
        this.FakDokumentID = input.FakDokumentID;
        this.VrstaStavkiID = input.VrstaStavkiID;
        this.TarifaID = input.TarifaID;
        this.Kolicina = input.Kolicina;
        this.Cena = input.Cena;
        this.RabatProc = input.RabatProc;
        this.RabatVred = input.RabatVred;
        this.Opis = input.Opis;    
        this.CenaSaPDV = input.CenaSaPDV;       
        this.RabatTip = input.RabatTip;
        //this.Rabat = { Type: this.RabatProc > 0 ? 0 : 1, PValue: this.RabatProc, VValue: this.RabatVred };
        this.Rabat = { Type: this.RabatTip, PValue: this.RabatProc, VValue: this.RabatVred };
        this.JedinicaMereID = input.JedinicaMereID;
        // this.Osnovica = input.Osnovica;   
        this.RobaUsluga=input.RobaUsluga;
        this.VrednostPreRabataStavke=input.VrednostPreRabataStavke;
        this.RabatStavke=input.RabatStavke;
        this.OsnovicaStavke=input.OsnovicaStavke;
        this.PdvStavke=input.PdvStavke;
        this.VrednostStavke=input.VrednostStavke;
        this.IdentifikatorKlasifikacije = input.IdentifikatorKlasifikacije;
        return this;
    }

    Serialize(input:FakDokumentStavka){
        input.RabatProc = input.RabatProc ? input.RabatProc : this.Rabat ? this.Rabat.RabatProc : 0;
        input.RabatVred = input.RabatVred ? input.RabatVred : this.Rabat ? this.Rabat.RabatVred : 0;
        input.RabatTip = input.RabatTip ? input.RabatTip : this.Rabat ? this.Rabat.RabatType : 0;
        return input;
    }
}